export const STYLIST_CARD_INSTAGRAM_CLASS =
    " text-sm md:text-base font-semibold  text-white font-Montserrat  pt-2";
